import { ExportButton } from '@/common/buttons/ExportButton';
import { TitleButton } from '@/common/buttons/TitleButton';
import { DashboardCard } from '@/common/dashboard/DashboardCard';
import { FilterContainer } from '@/common/dashboard/FilterContainer';
import { useDialog } from '@/common/dialog/DialogContext';
import { Form } from '@/common/form/Form';
import { useNavStateSync } from '@/common/hooks/navState/useNavStateSync';
import { MainBox } from '@/common/layout/MainBox';
import { Spacer, SpacerLayout } from '@/common/layout/SpacerLayout';
import { useNavState } from '@/common/navState/NavStateContext';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { Title } from '@/common/title/Title';
import { SaleStatusDefinitionsDialog } from '@/sc/entities/indirSale/dashboard/SaleStatusDefinitionsDialog';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { Box } from '@mui/material';
import { useEffect, useState } from 'react';
import { ChbkFinGrowthCards } from './ChbkFinGrowthCards';
import { ChbkFinTrendChart } from './ChbkFinTrendChart';
import { ChbkFinTrendGraph } from './ChbkFinTrendGraph';
import { ChbkFinTrendTableCard } from './ChbkFinTrendTableCard';

export const ChbkFinDashboard = () => {

  const rsrc = useRsrc();

  const { openDialog } = useDialog();
  const { navState } = useNavState();

  const [fieldDefs, setFieldDefs] = useState();
  const [formValues, setFormValues] = useNavStateSync('formValues');

  const [totalValues, setTotalValues] = useState();

  // const[channelIdToCode, setChannelIdToCode] = useState();

  useEffect(() => {
    const currentPeriodicity = formValues?.periodicity ?? 'MONTH';
    rsrc.data('sc', 'CHBK_FIN_DASHBOARD_FILTERS_DATA_PLUGIN', { periodicity: currentPeriodicity }).then(res => {
      setFieldDefs([
        currentPeriodicity === 'DAY' ? { field: 'chbkDate', displayName: 'Chargeback Date', type: 'DATE', values: res.chbkDate } :
        { field: 'chbkPeriodId', displayName: 'Chargeback Period', type: 'DROPDOWN', values: res.periods },
        { field: 'periodicity', displayName: 'Periodicity', type: 'DROPDOWN', values: [{ value: 'DAY', displayName: 'Day' }, { value: 'MONTH', displayName: 'Month' }, { value: 'QUARTER', displayName: 'Quarter' }] },
        { field: 'prodIds', displayName: 'Products', type: 'TREE', treeData: res.prodTreeData },
        { field: 'distCustIds', displayName: 'Distributors', type: 'TREE', treeData: res.distCustTreeData },
        // { field: 'channelIds', displayName: 'Channels', type: 'TREE', treeData: res.channelTreeData },
        { field: 'ctrtIds', displayName: 'Contracts', type: 'TREE', treeData: res.ctrtTreeData },
        { field: 'agg', displayName: 'Aggregate Value', type: 'DROPDOWN', values: [{ value: 'PAID_AMT', displayName: 'Paid Amount' }, { value: 'PAID_QTY', displayName: 'Paid Quantity' }] }
      ]);

      setTotalValues({
        totalProdIds: res.prodIds,
        totalDistCustIds: res.distCustIds,
        // totalChannelIds: res.channelIds
        totalCtrtIds: res.ctrtIds
      });

      if (!navState.formValues || !res.periods.map(p => p.value).includes(formValues.chbkPeriodId)) {
        let dateValue = {};
        if (currentPeriodicity === 'DAY') {
          dateValue = { chbkDate: res.chbkDate };
        } else {
          dateValue = { chbkPeriodId: res.periods[0].value };
        }

        setFormValues({
          ...dateValue,
          prodIds: formValues?.prodIds ?? res.prodIds,
          distCustIds: formValues?.distCustIds ?? res.distCustIds,
          // channelIds: formValues?.channelIds ?? res.channelIds,
          ctrtIds: formValues?.ctrtIds ?? res.ctrtIds,
          periodicity: formValues?.periodicity ?? 'MONTH',
          agg: formValues?.agg ?? 'PAID_AMT'
        });
      }

      // setChannelIdToCode(res.channelIdToCode);
    });
  }, [formValues?.periodicity]);

  const openDefinitionsDialog = () => {
    openDialog(SaleStatusDefinitionsDialog);
  }

  const formatPeriodicity = (periodicity) => {
    switch (periodicity) {
      case 'DAY':
        return 'Daily';
      case 'MONTH':
        return 'Monthly';
      case 'QUARTER':
        return 'Quarterly';
      default:
        return '';
    }
  }

  if (!fieldDefs) {
    return;
  }

  return (
    <MainBox>
      {/* Title */}
      <Box sx={{
        mb: 1, display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start'
      }}>
        <Title icon={fas.faTasks} title="Chargebacks Financial Dashboard" />
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }} >
          <TitleButton key="comparePolFormulaButton" icon={fas.faInfoCircle} toolTip="View Definitions" onClick={openDefinitionsDialog} />
          <ExportButton />
        </Box>
      </Box>

      {/* Filters */}
      <Form fieldDefs={fieldDefs} formValues={formValues} setFormValues={setFormValues} container={FilterContainer}/>

      <SpacerLayout>
        <Spacer vertical>

          {/* Row 1 */}
          <Spacer weights={[1, 1]}>
            <DashboardCard title={`${formatPeriodicity(formValues?.periodicity)} Paid Trends`} sx={{ flex: 1 }} >
              <ChbkFinTrendChart
                formValues={formValues}
                totalValues={totalValues}
                // channelIdToCode={channelIdToCode}
              />
            </DashboardCard>
            <ChbkFinTrendTableCard 
              formValues={formValues} 
              totalValues={totalValues} 
              // channelIdToCode={channelIdToCode} 
            />
          </Spacer>

          {/* Row 2 */}
          <Spacer weights={[1, 2]}>
            <ChbkFinGrowthCards 
            formValues={formValues} 
            totalValues={totalValues} 
            // channelIdToCode={channelIdToCode} 
            />
            <DashboardCard title="YoY Paid Trends">
              <ChbkFinTrendGraph
                formValues={formValues}
                totalValues={totalValues}
                // channelIdToCode={channelIdToCode}
              />
            </DashboardCard>
          </Spacer>

        </Spacer>
      </SpacerLayout>

    </MainBox >
  );
};